'use client';

import dynamic from 'next/dynamic';

// Динамически импортируем компонент без SSR
const HtmlContent = dynamic(() => import('./HtmlContent'), { ssr: false });

export default function HtmlContentWrapper({ html, className = '' }) {
    return <HtmlContent html={html} className={className} />;
}
